import { useDispatch } from 'react-redux';
import { changeVisiblePopup } from '~/Actions/ActionApp';
import { Button } from '~/components/Button/Buttons';
import { Popup, PopupFooter, PopupHeader } from '~/components/Popup/Popup';
import { t } from '~/utils/localization';

const ErrorPopup = () => {
    const dispatch = useDispatch();

    const onClose = () => {
        dispatch(changeVisiblePopup(null));
    };

    return (
        <Popup onClose={onClose} renderEscButton={true}>
            <PopupHeader title={t('Произошла ошибка. Повторите попытку позже')} />
            <PopupFooter>
                <Button label={t('Закрыть')} onClick={onClose} />
            </PopupFooter>
        </Popup>
    );
};

export default ErrorPopup;
